import React from 'react';
import { ErrorHeaderTh, FieldTd, joinNonEmpty, tableStyleBase, tableStyleErrorBase, ValueTd } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
export const IdBarcodeMismatchDetails = ({ ocrBarcodeMismatches, ocrData, barcodeData, customStyles }) => {
    // ocrData does not exist for old jobs
    if (!ocrData || ocrBarcodeMismatches.length === 0) {
        return null;
    }
    const ocrIdNumber = ocrData.id ?? null;
    const barcodeIdNumber = barcodeData?.id ?? null;
    const ocrName = joinNonEmpty([
        ocrData.firstName,
        ocrData.middleName,
        ocrData.lastName
    ]);
    const barcodeName = joinNonEmpty([
        barcodeData?.firstName,
        barcodeData?.middleName,
        barcodeData?.lastName
    ]);
    const ocrBirthDate = ocrData.birthDate ?? null;
    const barcodeBirthDate = barcodeData?.birthDate ?? null;
    return (React.createElement("table", { style: { ...tableStyleBase, ...tableStyleErrorBase, ...customStyles } },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement(ErrorHeaderTh, { width: "25%" }, "Field"),
                React.createElement(ErrorHeaderTh, { width: "40%" }, "OCR"),
                React.createElement(ErrorHeaderTh, { width: "40%" }, "Barcode")),
            ocrBarcodeMismatches.includes('id') && (React.createElement("tr", null,
                React.createElement(FieldTd, null, "ID Number"),
                React.createElement(ValueTd, null, ocrIdNumber),
                React.createElement(ValueTd, null, barcodeIdNumber))),
            ocrBarcodeMismatches.includes('fullName') && (React.createElement("tr", null,
                React.createElement(FieldTd, null, "Name"),
                React.createElement(ValueTd, null, ocrName),
                React.createElement(ValueTd, null, barcodeName))),
            ocrBarcodeMismatches.includes('birthDate') && (React.createElement("tr", null,
                React.createElement(FieldTd, null, "Birth Date"),
                React.createElement(ValueTd, null, ocrBirthDate),
                React.createElement(ValueTd, null, barcodeBirthDate))))));
};
